import React from 'react';

const Footer = () => {
    return (
        <div className="container footer p-5 bg-dark text-light text-center">
            <a className=" text-light px-3">Legal Notice</a>
            <a className=" text-light px-3">Privacy Policy </a>
            <a className=" text-light px-3 text-decoration-none">2021 @ All right reserved By Hasan Sarker  </a>
        </div>
    );
};

export default Footer;